import { type ReactNode } from 'react';

import { XStack, YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { FIELD_LABEL_CLASS, GAP } from '../tokens';

import { FieldError } from './FieldError';
import { FieldLabel } from './FieldLabel';
import './InlineField.css';

// A field's label in a narrow left column and its control beside it, as the To,
// Subject and Guests rows lay out
export const InlineField = ({
  id,
  label,
  labelsControl,
  error,
  labelHidden,
  recipient,
  children,
}: {
  id: string;
  label: string | undefined;
  labelsControl: boolean;
  error: string | undefined;
  labelHidden?: boolean;
  recipient?: boolean;
  children: ReactNode;
}) => (
  <div className="card-inline-field w-full min-w-0">
    <XStack
      data-recipient-field={recipient || undefined}
      className={cn(
        'min-w-0 items-start',
        GAP.sm,
        label && !labelHidden && 'card-field-labelled',
        recipient && 'min-h-[calc(32*var(--ac-u))]'
      )}
    >
      {label ? (
        <FieldLabel
          id={id}
          labelsControl={labelsControl}
          text={label}
          className={cn(
            FIELD_LABEL_CLASS,
            recipient &&
              'min-w-[calc(36*var(--ac-u))] w-[calc(36*var(--ac-u))] pt-[calc(4*var(--ac-u))] leading-[calc(24*var(--ac-u))]'
          )}
          hidden={labelHidden}
        />
      ) : null}
      <YStack className={cn('card-field-control min-w-0 flex-1', GAP.xs)}>
        {children}
        <FieldError id={id} error={error} />
      </YStack>
    </XStack>
  </div>
);
